import React, { useState, useEffect } from "react";
import { Tab, Tabs } from "@mui/material";
import { useNavigate, useLocation } from "react-router-dom";
import TabPanel from "../../components/common/tabpannel/Tabpannel";
import Dashboardtab from "./dashboardtab/Dashboardtab";
import Goalsettingstab from "./goalsetting/Goalsettingtab";
import Medicalappointmenttab from "./medicalappoinmet/Medicalappoinmenttab";

const Healthandfitness = () => {
  const [selectedTab, setSelectedTab] = useState(0);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (location.pathname === "/healthandfitness/dashboard") {
      setSelectedTab(0);
    } else if (location.pathname === "/healthandfitness/goalsetting") {
      setSelectedTab(1);
    } else if (location.pathname === "/healthandfitness/medicalappointments") {
      setSelectedTab(2);
    }
  }, [location.pathname]);

  const handleTabChange = (event, newValue) => {
    setSelectedTab(newValue);

    if (newValue === 0) {
      navigate("/healthandfitness/dashboard");
    } else if (newValue === 1) {
      navigate("/healthandfitness/goalsetting");
    } else if (newValue === 2) {
      navigate("/healthandfitness/medicalappointments");
    }
  };

  return (
    <div>
      <Tabs
        value={selectedTab}
        variant="scrollable"
        scrollButtons="auto"
        allowScrollButtonsMobile
        onChange={handleTabChange}
        aria-label="health and fitness tabs"
      >
        <Tab label="Dashboard" id="tab-0" aria-controls="tabpanel-0" />
        <Tab label="Goal Setting" id="tab-1" aria-controls="tabpanel-1" />
        <Tab label="Medical Appointments" id="tab-2" aria-controls="tabpanel-2" />
      </Tabs>

      <div className="p-5">
        <TabPanel value={selectedTab} index={0}>
          <Dashboardtab />
        </TabPanel>

        <TabPanel value={selectedTab} index={1}>
          <Goalsettingstab />
        </TabPanel>

        <TabPanel value={selectedTab} index={2}>
          <Medicalappointmenttab />
        </TabPanel>
      </div>
    </div>
  );
};

export default Healthandfitness;
